// extracted by mini-css-extract-plugin
module.exports = {"lpHeroContainer":"LPHero-module__lpHeroContainer___12LlR","shopifyContainer":"LPHero-module__shopifyContainer___3sNb1"};